import moment from "moment-timezone";
import { Container } from "react-bootstrap";
import { Link } from "react-router";

export default function Footer() {
  return (
    <footer className="footer">
      <Container>
        <div className="footer-content">
          <div>
            ©{moment().format("YYYY")} Liberty Connect. All rights reserved.
          </div>
          <div className="footer-links">
            <Link to="/page/privacy">Privacy Policy</Link>
            <Link to="/page/tos">Terms of Service</Link>
          </div>
        </div>
      </Container>
    </footer>
  );
}
